import chroma from "chroma-js";
import { Color, Vector } from "p5";
import { seedBrush, initialBrushSpeed } from "../TypesAndConstants/const";
import {
  BackgroundImage,
  BrushModes,
  ShapeSetting,
  SketchProps,
} from "../TypesAndConstants/types";
import Pen from "./SketchUtilities/Pen";
import Shape from "./SketchUtilities/Shape";
import Spring from "./SketchUtilities/Spring";
import { THREE_INST } from "./SketchUtilities/Three/threeSingleton";
import Wiper from "./SketchUtilities/Wipers";
import { getMouseOrientation } from "../getMouseOrientation";
export interface SpringInit {
  topSpeed: number;
  mass: number;
}

export default function sketch(p: any) {
  p.disableFriendlyErrors = true;
  let colorTransitionSpeed = 0.01;
  let activeBrush: number = seedBrush;
  let width: number = 0;
  let height: number = 0;
  let brushSize: number = 25;
  let brushSpeed: number = initialBrushSpeed;
  let brushType: BrushModes = "spring";
  let amp: number = 0;
  let alpha: number = 1;
  let darkness: number = 0;
  let variations: number = 0;
  let isColorfillMode: boolean = false;
  let isColorSelect: boolean = false;
  let currentColor: string = "#009FE4";
  let growShrink: "grow" | "shrink" = "grow";
  let penCounter: number = 0;
  let penPath: number = 0;
  let penRadius: number = 0;
  let penSpeed: number = 0;
  let wipeDirection: string;
  let wipeCount: number = 8;
  let wipeSpan: number = 5;
  let stopClickEvents: boolean = false;
  let shapeSettings: ShapeSetting = {
    shape: 0,
    shapeSize: 100,
    shapeRotation: "drag",
  };
  let canvasContext: CanvasRenderingContext2D;
  let multiColor: boolean = false;
  let colorIsAnimated: boolean = false;
  let isPortrait: boolean = false;
  let wipeCounter: number = p.height;
  let canvasSize: { width: number, height: number } = {width: 0, height: 0};
  let wipeOffset: number = 0;
  let shape: Shape | undefined;
  const pen = new Pen(p);
  let colorVariations: string[] = [];
  let arraySize = 250;
  let variationIndex = 0;
  let variationCounter = 0;
  let colorArray: Color[] = [
    p.color("#594f4f"),
    p.color("#547980"),
    p.color("#45ada8"),
    p.color("#9de0ad"),
    p.color("#e5fcc2"),
  ];

  let brushCount: number = 0;

  let springs: Spring[] = [];
  let wipers: Wiper[] = [];
  let locations: Vector[] = [];
  // Image History
  let undoState: boolean = false;
  // const images: BackgroundImage[] = [];

  let setLocations: (vec: Vector[]) => void | undefined;
  let setGlobalColor: (color: string) => void;
  let setColorFromSelect: (color: string) => void;
  let three = THREE_INST.getInst();

  let velocities: SpringInit[] = [
    {
      topSpeed: 2,
      mass: 20,
    },
    {
      topSpeed: 2.5,
      mass: 15,
    },
    {
      topSpeed: 3.5,
      mass: 8,
    },
    {
      topSpeed: 4.5,
      mass: 4,
    },
    {
      topSpeed: 6,
      mass: 1.5,
    },
  ];
  const updateColorVariations = ()=>{
    let size = arraySize;
    colorVariations = [];
    while (size--) colorVariations.push(chroma.random().hex());
  }

  updateColorVariations();
  const setActiveBrushes = function (activeBrushes: number) {
    if (springs.length === 0) return;
    springs.forEach((brush, index) => {
      if (index < activeBrushes) {
        brush.setActive();
        return;
      }
      brush.setInactive();
    });
  };

  const setActiveWipers = function (activeWipers: number) {
    if (wipers.length === 0) return;
    wipers.forEach((wiper, index) => {
      if (index < activeWipers) {
        wiper.setActive();
        return;
      }
      wiper.setInactive();
    });
  };

  const setBrushSpeed = function (brushSpeed: number) {
    springs.forEach((i) => {
      i.setBrushSpeed(brushSpeed);
    });
  };

  const setBrushSize = function (bSize: number) {
    if (bSize !== brushSize) {
      brushSize = bSize;
      three.obj.setBrushSize(brushSize);
    }
  };

  const initWipers = function () {
    for (var x = 0; x < 15; x++) {
      const wiper = new Wiper(currentColor, p, x);

      if (x < 8) {
        wiper.setActive();
      } else {
        wiper.setInactive();
      }
      wipers.push(wiper);
    }
  };

  const initSprings = function () {
    for (var x = 0; x < 5; x++) {
      const brush = new Spring(
        currentColor,
        velocities[x].topSpeed,
        velocities[x].mass,
        p,
        x
      );

      // Init with 3 active springs

      if (x < 3) {
        brush.setActive();
      } else {
        brush.setInactive();
      }

      springs.push(brush);
    }
  };

  // Streaming Utils

  three.obj.drawTo2d = () => {
    const canvas = three.obj.context!.canvas;
    (canvasContext as any).drawingContext.drawImage(
      canvas,
      0,
      0,
      canvas.width,
      canvas.height,
      0,
      0,
      p.width,
      p.height,
      (canvasContext as any).canvas.height
    );
  };

  three.obj.initStreaming = () => {
    const img = three.obj.getCurrentImage();
    if (!img) return;
    drawImage(img);
  };

  // End Streaming Utils
  p.setup = function () {
    canvasContext = p.createCanvas(width, height);
    initWipers();
    initSprings();
    updateColorVariations()
    three.obj.initTextures().then(async (resp: any) => {
      await resp().then(() => {
        three.obj.run({ width, height });
        three.obj.setTexture(seedBrush, brushSize);
        three.obj.setPreviewTexture(seedBrush);
      });
    });
  };

  const performUndo = function () {
    p.clear();
    const img = three.obj.performUndo();
    if (img) {
      drawImage(img);
    }
  };

  const drawImage = ({ image: img }: BackgroundImage) => {
    (canvasContext as any).drawingContext.drawImage(
      img,
      0,
      0,
      img.width,
      img.height,
      0,
      0,
      p.width,
      p.height,
      (canvasContext as any).canvas.height
    );
  };

  p.updateWithProps = function (props: SketchProps) {
    if (props.brushColor) {
      if (props.brushColor.length > 1) {
        multiColor = true;
        colorArray = props.brushColor.map((i) => {
          return p.color(i);
        });
        colorArray.push(colorArray[3]);
        colorArray.push(colorArray[2]);
        colorArray.push(colorArray[1]);
      } else {
        currentColor = p.color(props.brushColor[0]);
        multiColor = false;
      }
    }

    isPortrait = props.isPortrait;
    canvasSize = props.canvasSize;

    if (colorTransitionSpeed !== props.colorTransitionSpeed) {
      colorTransitionSpeed = props.colorTransitionSpeed;
    }

    if (props.drawnOnMobile !== three.obj.isMobile) {
      three.obj.isMobile = props.drawnOnMobile;
    }

    if (setColorFromSelect === undefined) {
      setColorFromSelect = props.setColorFromSelect;
    }

    if (canvasContext !== undefined && shape && !shape.canvasContext) {
      shape.setContext(canvasContext);
    }

    if (shape === undefined && props.shape) {
      shape = props.shape;
      shape.setP5Inst(p);
    } else if (
      (shapeSettings.shape !== props.shapeSettings.shape ||
        shapeSettings.shapeRotation !== props.shapeSettings.shapeRotation ||
        shapeSettings.shapeSize !== props.shapeSettings.shapeSize) &&
      shape !== undefined
    ) {
      shapeSettings = props.shapeSettings;
      shape.setBrushSize(shapeSettings.shapeSize);
    }

    if (activeBrush !== props.activeBrush) {
      activeBrush = props.activeBrush;
    }

    if (colorIsAnimated !== props.colorIsAnimated) {
      colorIsAnimated = props.colorIsAnimated;
    }

    if (props.globalColorData.alpha !== alpha) {
      alpha = props.globalColorData.alpha;
      three.obj.setOpacity(alpha);
    }

    if (props.globalColorData.darkness !== darkness) {
      darkness = props.globalColorData.darkness;
    }

    if (props.globalColorData.variations !== variations) {
      variations = props.globalColorData.variations;
    }

    if (props.growShrink !== growShrink) {
      growShrink = props.growShrink;
    }

    if (props.penPath !== penPath) {
      penPath = props.penPath;
    }

    if (props.penSpeed !== penSpeed) {
      penSpeed = props.penSpeed / 20;
    }

    if (props.penRadius !== penRadius) {
      penRadius = props.penRadius;
    }

    if (props.history.performUndo !== undoState) {
      undoState = props.history.performUndo;
      performUndo();
    }

    if (
      props.dimensions &&
      (props.dimensions.height !== height || props.dimensions.width !== width)
    ) {
      height = props.dimensions.height;
      width = props.dimensions.width;
      const img = three.obj.getCurrentImage();
      p.resizeCanvas(width, height);
      three.obj.updateCamera(props.dimensions);

      if (img) {
        drawImage(img);
      }
    }

    if (props.brushType !== brushType) {
      if (brushType === "growshrink" && props.brushType !== "growshrink") {
        three.obj.setBrushSize(brushSize);
      }
      if (props.brushType === "wipe" && brushType !== "wipe") {
        three.obj.brushCount = wipeCount;
      }

      if (props.brushType !== "wipe" && brushType === "wipe") {
        three.obj.brushCount = brushCount;
      }

      if (props.brushType === "shape" && brushType !== "shape") {
        three.obj.flattenCanvasAndSetAsDisplkay(drawImage);
        p.clear();
        three.obj.clear();
      }

      three.obj.isShape = props.brushType === "shape";

      brushType = props.brushType;
    }

    if (props.brushSize !== brushSize) {
      setBrushSize(props.brushSize);
    }

    if (props.brushCount !== brushCount) {
      setActiveBrushes(props.brushCount);
      brushCount = props.brushCount;
      three.obj.brushCount = props.brushCount;
    }

    if (props.brushSpeed !== brushSpeed) {
      console.info("brush speed baskSketch " + brushSpeed )
      setBrushSpeed(brushSpeed);
      brushSpeed = props.brushSpeed;
    }

    if (props.isColorfillMode !== isColorfillMode) {
      isColorfillMode = props.isColorfillMode;
      three.obj.isColorfill = props.isColorfillMode;
    }

    if (props.isColorSelect !== isColorSelect) {
      isColorSelect = props.isColorSelect;
      three.obj.isColorSelect = props.isColorSelect;
    }

    if (setLocations === undefined) {
      setLocations = props.setLocations;
    }

    if (setGlobalColor === undefined) {
      setGlobalColor = props.setGlobalColor;
    }

    if (wipeCount !== props.wipeCount) {
      setActiveWipers(props.wipeCount);
      wipeCount = props.wipeCount;
      updateWipeSpan();
    }

    if (wipeDirection !== props.wipeDirection) {
      wipeDirection = props.wipeDirection;
    }

    if (wipeSpan !== props.wipeSpan) {
      wipeSpan = props.wipeSpan / 50;
      updateWipeSpan();
    }

    if (props.wipeSpeed !== amp) {
      wipers.forEach((i) => {
        i.setAmplitude(props.wipeSpeed);
        amp = props.wipeSpeed;
      });
    }

    if (stopClickEvents !== props.stopClickEvents) {
      stopClickEvents = props.stopClickEvents;
    }
  };

  let scaleIndex = 0;
  let c1Index = 0;
  let c2Index = 1;

  const getAnimatedColor = function () {
    return chroma.mix(
     
      colorArray[c1Index].toString(),
      colorArray[c2Index].toString(),
      scaleIndex
    );
  };

  let variationColor1: string = currentColor;
  let variationColor2: string = colorVariations[0];

  const getVariationColor = function () {
    variationColor2 = variationColor2 || colorVariations[0];
    return chroma.mix(variationColor1, variationColor2, variationCounter);
  };

  const handleColorVariations = function () {
    if (variationCounter >= 1) {
      variationColor1 = variationColor2;
      variationColor2 =
        variationIndex >= variations
          ? (currentColor as any).toString("#rrggbb")
          : colorVariations[variationIndex];
      if (variationIndex >= variations) {
        variationIndex = 0;
      }
      variationIndex++;
      variationCounter = 0;
    }
    variationCounter += colorTransitionSpeed;
  };

  const setOpacityDarkness = (c: Color) => {
    const color = chroma(c.toString("#rrggbb"))
      .alpha(alpha)
      .darken(darkness)
      .hex();
    return p.color(color);
  };

  const alterColor = function () {
    if (scaleIndex > 1.0) {
      c1Index = (c1Index + 1) % 7;
      c2Index = (c2Index + 1) % 7;
      scaleIndex = 0;
    }
    scaleIndex += colorTransitionSpeed;
  };

  const setWipeDown = () => {
    wipeCounter += 1;
    if (wipeCounter > height) {
      wipeCounter = 0;
    }
  };

  const setWipeUp = () => {
    wipeCounter -= 1;
    if (wipeCounter <= 0) {
      wipeCounter = height;
    }
  };

  const setWipeLeft = () => {
    wipeCounter -= 1;
    if (wipeCounter <= 0) {
      wipeCounter = width;
    }
  };

  const setWipeRight = () => {
    wipeCounter += 1;
    if (wipeCounter > width) {
      wipeCounter = 0;
    }
  };

  const updateWipeSpan = () => {
    wipeOffset = (wipeCount * wipeSpan) / 2;
  };

  const mouseIsOnCanvas = () => {
    const mCoords = getMouseOrientation(
      three.obj.isMobile,
      isPortrait,
      p.mouseX,
      p.mouseY,
      p.height
    );
    return (
      mCoords.y < height && mCoords.y > 0 && mCoords.x < width && mCoords.x > 0
    );
  };

  const getNoise = (theta: number, scale: number, newSeed?: number) => {
    if (newSeed) {
      p.noiseSeed(newSeed);
    }
    return p.noise(theta) * scale;
  };

  const drawSprings = () => {
    const locations: Vector[] = [];
    springs.forEach((i: Spring) => {
      i.spring(three.obj.isMobile, isPortrait);
      if (i.isActive) locations.push(i.getLocation());
    });
    return locations;
  };

  const wipeLandscape = () => {
    let xAxis = false;
    switch (wipeDirection) {
      case "left":
        setWipeLeft();
        xAxis = true;
        break;
      case "up":
        setWipeUp();
        break;
      case "right":
        xAxis = true;
        setWipeRight();
        break;
      case "bottom":
        setWipeDown();
        break;
    }
    return xAxis;
  };
  const wipePortrait = () => {
    let xAxis = false;
    switch (wipeDirection) {
      case "left":
        setWipeUp();
        break;
      case "up":
        setWipeRight();
        xAxis = true;
        break;
      case "right":
        setWipeDown();
        break;
      case "bottom":
        setWipeLeft();
        xAxis = true;
        break;
    }
    return xAxis;
  };

  const drawWipers = () => {
    const usePortrait = three.obj.isMobile && isPortrait;
    const xAxis = !usePortrait ? wipeLandscape() : wipePortrait();

    const locations: Vector[] = [];
    const mCoords = getMouseOrientation(
      three.obj.isMobile,
      isPortrait,
      p.mouseX,
      p.mouseY,
      p.height
    );
    wipers.forEach((i: Wiper) => {
      if (xAxis) {
        i.wipeHorizontal(wipeCounter, wipeSpan, wipeOffset, mCoords.y);
      } else {
        i.wipeVertical(wipeCounter, wipeSpan, wipeOffset, mCoords.x);
      }

      if (i.isActive) locations.push(i.getLocation());
    });
    return locations;
  };

  const incPen = () => {
    return (penCounter += penSpeed);
  };

  const drawPen = () => {
    const mCoords = getMouseOrientation(
      three.obj.isMobile,
      isPortrait,
      p.mouseX,
      p.mouseY,
      p.height
    );
    return pen.calcPath(
      penPath,
      incPen(),
      penSpeed,
      penRadius,
      mCoords.x,
      mCoords.y
    );
  };

  const drawGrowShrink = () => {
    const speed = 41 - brushSpeed;
    if (stopClickEvents) return;

    if (growShrink === "grow") {
      pen.updateCanvasSize( canvasSize )
      pen.grow(speed);
    } else {
      pen.updateCanvasSize( canvasSize )
      pen.shrink(speed);
    }
  };

  three.obj.p5SelectColor = () => {
    const mCoords = getMouseOrientation(
      three.obj.isMobile,
      isPortrait,
      p.mouseX,
      p.mouseY,
      p.height
    );
    if (!mouseIsOnCanvas()) {
      return;
    }
    const selectedColor = (canvasContext as any).drawingContext.getImageData(
      mCoords.x,
      mCoords.y,
      canvasContext.canvas.width,
      canvasContext.canvas.height
    );
    setColorFromSelect(
      `rgb(${selectedColor.data[0]},${selectedColor.data[1]},${selectedColor.data[2]})`
    );
  };

  const setColorFillFuzziness = function (
    val1: number,
    val2: number,
    fuzz: number = 30
  ) {
    return Math.abs(val1 - val2) < fuzz;
  };

  three.obj.p5DrawFill = () => {
    if (!mouseIsOnCanvas()) {
      return;
    }
    const mCoords = getMouseOrientation(
      three.obj.isMobile,
      isPortrait,
      p.mouseX,
      p.mouseY,
      p.height
    );
    const selectedColor = (canvasContext as any).drawingContext.getImageData(
      mCoords.x,
      mCoords.y,
      canvasContext.canvas.width,
      canvasContext.canvas.height
    );

    const colorData = (canvasContext as any).drawingContext.getImageData(
      0,
      0,
      canvasContext.canvas.width,
      canvasContext.canvas.height
    );

    const currentArray = chroma(
      setOpacityDarkness(currentColor as any).toString("#rrggbb")
    ).rgb();

    for (var x = 0; x < colorData.data.length; x += 4) {
      if (
        setColorFillFuzziness(colorData.data[x], selectedColor.data[0]) &&
        setColorFillFuzziness(colorData.data[x + 1], selectedColor.data[1]) &&
        setColorFillFuzziness(colorData.data[x + 2], selectedColor.data[2])
      ) {
        colorData.data[x] = currentArray[0];
        colorData.data[x + 1] = currentArray[1];
        colorData.data[x + 2] = currentArray[2];
      }
    }

    (canvasContext as any).drawingContext.putImageData(colorData, 0, 0);
  };

  three.obj.p5DrawStub = () => {
    locations.length = 0;
    three.obj.globalNoise = getNoise(p.millis(), 5);

    let color = currentColor;
    if (colorIsAnimated) {
      alterColor();
      handleColorVariations();

      if (multiColor) {
        color = getAnimatedColor().hex();
      } else if (variations > 1) {
        color = getVariationColor().hex();
      }
    }

    color = setOpacityDarkness(color as any);
    if (setGlobalColor) {
      setGlobalColor((color as any).toString("#rrggbbaa"));
    }
    if (brushType === "shape") {
      three.obj.currentColor = color;
    }  

    three.obj.setColor((color as any).toString("#rrggbb"));
    const mCoords = getMouseOrientation(
      three.obj.isMobile,
      isPortrait,
      p.mouseX,
      p.mouseY,
      p.height
    );

    switch (brushType) {
      case "wipe":
        three.obj.brushCount = wipeCount;
        locations = drawWipers();
        break;
      case "spring":
      case "pen":
        if( penPath > 0 ) {
          three.obj.brushCount = 1;
          const penVectors = drawPen();
          locations = [penVectors];
        } else {
          three.obj.brushCount = brushCount;
          locations = drawSprings();
        }
        break;
      // case "pen":
      //   three.obj.brushCount = 1;
      //   const penVectors = drawPen();
      //   locations = [penVectors];
      //   break;
      case "growshrink":
        three.obj.brushCount = 1;
        const vectors = p.createVector(mCoords.x, mCoords.y);
        locations = [vectors];
        drawGrowShrink();
        break;
      case "shape":
      default:
        break;
    }

    three.obj.isMouseOnCanvas = mouseIsOnCanvas();
    //three.obj.setTexture(activeBrush, brushSize);
    if (setLocations) {
      setLocations(locations);
      three.obj.setMouseCoords(locations);
    }
  };
}
